import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, MenuItem } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { AccountCircle as UserIcon, Edit as EditIcon } from '@mui/icons-material';
import api from '../services/api';

const UserModal = ({ open, onClose, user, fetchUsers }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('Ativo');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setUsername(user.username);
      setStatus(user.status === 1 ? 'Ativo' : 'Inativo');
    } else {
      setUsername('');
      setPassword('');
      setStatus('Ativo');
    }
  }, [user]);

  const handleSave = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(username)) {
      setError('Por favor, insira um e-mail válido.');
      return;
    }

    const sanitizedUsername = username.trim().toLowerCase();
    const updatedUser = {
      username: sanitizedUsername,
      status: status === 'Ativo' ? 1 : 0,
      password: password,
    };

    try {
      if (user) {
        await api.put(`/users/update-username/${user.id}`, { username: updatedUser.username });
        await api.put(`/users/update-status/${user.id}`, { status: updatedUser.status });
      } else {
        await api.post('/users/create-user', updatedUser);
      }
      fetchUsers();
      onClose();
      Swal.fire({
        icon: 'success',
        title: user ? 'Usuário atualizado com sucesso' : 'Usuário criado com sucesso',
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        navigate('/dashboard');
      });
    } catch (error) {
      console.error('Failed to save user', error);
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao salvar o usuário.',
        showConfirmButton: true
      });
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ width: 300, padding: 2, margin: 'auto', marginTop: '10%', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
          {user ? <EditIcon /> : <UserIcon />}
          <Typography variant="h6" gutterBottom sx={{ marginLeft: 1 }}>{user ? 'Editar Usuário' : 'Adicionar Usuário'}</Typography>
        </Box>
        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          margin="normal"
          error={!!error}
          helperText={error}
        />
        {!user && (
          <TextField
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            type="password"
            required
          />
        )}
        <TextField
          select
          label="Status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          fullWidth
          margin="normal"
        >
          <MenuItem value="Ativo">Ativo</MenuItem>
          <MenuItem value="Inativo">Inativo</MenuItem>
        </TextField>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Salvar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UserModal;
